import {GROUP_SELECT} from "../../../../gd/const/fields/field2-groups"
import SessionCustomField from "../../../../model2/custom-field/session-custom-field"
import {FieldType} from "../../../field-type"
import CustomFieldsV1 from "../../../../gd/const/fields/custom-fields-v1"
import FieldDropdown from "../../dropdown/dropdown"
import FieldConfig from "../../../proto/field-config"
import FieldInternalDatabase_ManagementForm from "./render/management-form"
import FieldInternalDatabase_ManagementFormCFV1 from "./render/management-form-cfv1"
import FieldInternalDatabase_TListGroupHeader1 from "./render/list-group-header-1"
import FieldInternalDatabase_TListGroupHeader2 from "./render/list-group-header-2"
import {ColorPalette, ItemColorCoding} from "../../../color-coding/color-coding";

// const debug = "FieldInternalDatabase"
const debug = false

export default class FieldInternalDatabase extends FieldDropdown {

    constructor(config: FieldConfig) {
        super(config);

        this.typeInteger            = CustomFieldsV1.type.INTERNAL_DB
        this.typeLabel              = "Internal Database"
        this.typeGroup              = GROUP_SELECT
        this.typeDescription        = "Option select (dropdown) field from custom database items"

        this.icon                   = 'ii5-database'

        // this.renderComponents.managementForm        = FieldInternalDatabase_ManagementForm
        this.renderComponents.managementFormCFV1    = FieldInternalDatabase_ManagementFormCFV1

        this.renderComponents.tlistGroupHeader1     = FieldInternalDatabase_TListGroupHeader1
        this.renderComponents.tlistGroupHeader2     = FieldInternalDatabase_TListGroupHeader2

        // temp solution - see getGraphColor
        this.isColorCodingAvailable = true

    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldInternalDatabase({
            fieldId         : customFieldV1.id,
            label           : customFieldV1.name,
            type            : FieldType.INTERNAL_DB,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }

    /*** DATA FUNCTIONS ***/
    getOptions() {

        // failsafe check just in case
        if (!this.fieldParams.referenceProjectId) {
            console.error("#09de833 no ref project ID")
            return []
        }

        const internalDatabase = gd.databases.getInternalDB(this.fieldParams.referenceProjectId)

        if (!internalDatabase) {
            console.error("#dd343zz no DB found")
            return []
        }

        return internalDatabase.toOptions()


    }

    getGroupObject(value: any) {
        const found = this._getOption(value)

        return {
            id      : found ? found.value : value,
            value   : found ? found.value : value,
            label   : found ? found.label : value,
            name    : _.get(found, 'label', 'Not defined'),
        }
    }




    getColorCoding(model: any): ItemColorCoding {
        return {
            colorNumber     : gd.utils.randomInt(38, 0),
            corePalette     : ColorPalette.CORE
        }
    }

    getGraphColor(model: any, params: any): string {
        // const value = this.getViewValue(model)
        // const colorNumber = _.get(this._getOption(value),'color', null)

        const colorNumber = gd.utils.randomInt(38, 0)


        const color = colorNumber ? gd.skin.colors.getCoreColorHEX(colorNumber) : null

        debug && console.log(debug, 'getGraphColor', colorNumber, color, model, params)

        return color ? color : super.getGraphColor(model, params);
    }


}
